import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';
import { toast } from 'react-toastify';

const ResendModal = ({ open, onClose, sendReceiptUrl, recipientsUrl, recipientCount = 0, defaultEmail, csrfToken }) => {
  const [email, setEmail] = useState(defaultEmail || '');
  const [submitting, setSubmitting] = useState(false);
  const [confirmingRecipients, setConfirmingRecipients] = useState(false);
  const [sendingRecipients, setSendingRecipients] = useState(false);

  const TOAST_OPTS = { position: toast.POSITION.TOP_CENTER, hideProgressBar: true };
  const plural = recipientCount === 1 ? '' : 's';

  const close = () => {
    setConfirmingRecipients(false);
    onClose();
  };

  const submit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(sendReceiptUrl, { email })
      .then(() => {
        toast.success('Confirmation resent', TOAST_OPTS);
        close();
      })
      .catch((err) => {
        const msg = err.response && err.response.data ? [].concat(err.response.data).join(', ') : 'Failed to resend';
        toast.error(msg, TOAST_OPTS);
      })
      .then(() => setSubmitting(false));
  };

  const resendToRecipients = () => {
    setSendingRecipients(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(recipientsUrl, {})
      .then(({ data }) => {
        const count = (data && data.count) || recipientCount;
        toast.success(`Tickets resent to ${count} recipient${count === 1 ? '' : 's'}`, TOAST_OPTS);
        close();
      })
      .catch(() => toast.error('Failed to resend to recipients', TOAST_OPTS))
      .then(() => setSendingRecipients(false));
  };

  return (
    <Popup open={open} onClose={close} closeOnDocumentClick modal className="popup-modal">
      <div className="op-modal">
        <div className="op-modal-head">
          <h2 className="op-section-title">Resend confirmation</h2>
          <button type="button" className="op-modal-close" aria-label="Close" onClick={close}>×</button>
        </div>
        <p className="op-modal-subtitle">Send another transfer confirmation email.</p>

        <form className="op-resend-form" onSubmit={submit}>
          <label className="op-label" htmlFor="op-resend-email">Recipient email</label>
          <input id="op-resend-email" className="op-input" type="email" value={email}
                 onChange={(e) => setEmail(e.target.value)} required />
          <div className="op-modal-actions">
            <button type="button" className="op-btn" onClick={close}>Cancel</button>
            <button type="submit" className="op-btn op-btn-primary" disabled={submitting}>
              {submitting ? 'Sending…' : 'Resend email'}
            </button>
          </div>
        </form>

        {recipientCount > 0 && (
          <div className="mt-3">
            <hr className="my-3" />
            <h3 className="h6 mb-1">Bulk resend</h3>
            <p className="text-muted small mb-3">
              {`Send a new confirmation to all ${recipientCount} transfer recipient${plural}.`}
            </p>
            {confirmingRecipients ? (
              <React.Fragment>
                <p className="text-muted small mb-2">
                  {`Each recipient gets only their own tickets. Send to ${recipientCount} recipient${plural}?`}
                </p>
                <div className="d-flex justify-content-end">
                  <button type="button" className="btn btn-setlist-secondary mr-2" onClick={() => setConfirmingRecipients(false)} disabled={sendingRecipients}>Cancel</button>
                  <button type="button" className="btn btn-setlist-primary" onClick={resendToRecipients} disabled={sendingRecipients}>
                    {sendingRecipients ? 'Sending…' : `Send to ${recipientCount}`}
                  </button>
                </div>
              </React.Fragment>
            ) : (
              <div className="d-flex justify-content-end">
                <button type="button" className="btn btn-setlist-primary" onClick={() => setConfirmingRecipients(true)}>
                  {`Resend to all ${recipientCount} recipient${plural}`}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </Popup>
  );
};

export default ResendModal;
